import { useState, useEffect, useCallback } from "react";
// styles
import "../pages.css";
// utils
import XGridDemo from "../../components/utils/grid/Xgrid";
import Filtros from "../../components/filtros/Filtros";
// consts
import { ventas as titles } from "../../consts/titulos-de-tablas";
import { Routes } from "../../consts/Routes-App";
//Assets
import CircularIndeterminate from "../../components/utils/spinner/Spinner";
//Services
import { MWVentaGet } from "../../services/hooli-services";
// recoil
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import {
  routeInfo,
  rowSelected,
  userCredentials,
} from "../../recoilState/GlobalState";
import { transformDate } from "../../services/Local-services";
import { ACTIONS } from '../../consts/Actions';
import VentasDetail from './Actions/VentasDetail';
import Modal from '../../components/Modal/Modal';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import { HeaderButton } from "../../components";

const metodos = [
  {
    metodoId: "",
    metodoNombre: "Todos"
  },
  {
    metodoId: "H",
    metodoNombre: "Billetera"
  },
  {
    metodoId: "C",
    metodoNombre: "Tarjeta crédito"
  },
  {
    metodoId: "D",
    metodoNombre: "Tarjeta de debito"
  },
  // {
  //   metodoId: "",
  //   metodoNombre: "Creditos"
  // },
]

const canales = [
  {
    canalId: "",
    canalNombre: "Todos"
  },
  {
    canalId: "Q",
    canalNombre: "QR"
  },
  {
    canalId: "W",
    canalNombre: "Web"
  },
  {
    canalId: "A",
    canalNombre: "App"
  },
  {
    canalId: "E",
    canalNombre: "Débito automaitico"
  }
]
const estados = [
  { estadoId: '', estadoNombre: 'Todos' },
  { estadoId: 'Z', estadoNombre: 'Rechazado' },
  { estadoId: 'R', estadoNombre: 'Cancelado' },
  { estadoId: 'A', estadoNombre: 'Autorizado' },
  { estadoId: 'C', estadoNombre: 'Acreditado' },
  { estadoId: 'P', estadoNombre: 'Pendiente de pago' },
  { estadoId: 'B', estadoNombre: 'Reversado' },
];

export default function Ventas() {
  const [ventas, setVentas] = useState([]);
  const [filtros, setFiltros] = useState({
    desde: new Date().toISOString().substring(0, 10),
    hasta: new Date().toISOString().substring(0, 10),
    canal: "",
    metodoDePago: "",
    dni: "",
    comprobante: "",
    estado: ""
  });
  const [cargando, setCargando] = useState(false);
  const [modalDetails, setModalDetails] = useState({ isOpen: false });
  const [page, setPage] = useState(0);
  const [row, setRow] = useRecoilState(rowSelected);
  const setRoute = useSetRecoilState(routeInfo);
  const credentials = useRecoilValue(userCredentials);

  const loadPage = useCallback(
    (page, pageSize) => {
      retrieveVentas(page, pageSize);
    },
    [page]
  );
  const closeModal = () => {
        setModalDetails({ isOpen: false });
    };
  const handleClick = ({ procede, title }) => {
        setModalDetails({ procede, title, isOpen: true });
    };
  async function retrieveVentas(page, pageSize) {
    console.log(filtros)
    setCargando(true);
    const payload = {
      ...credentials,
      merchantId: credentials.merchantId,
      fechaDesde: filtros.desde,
      fechaHasta: filtros.hasta,
      canal: filtros.canal,
      metodoDePago: filtros.metodoDePago,
      dni: filtros.dni,
      comprobante: filtros.comprobante,
      estado: filtros.estado,
      page: page,
      pageSize: pageSize || 14,
    };
    const result = await MWVentaGet(payload);
    const ventas = result.reduce((acc, item, index) => {
      const {
        merchantVentaMonto,
        merchantVentaNombreCompleto,
        merchantVentaNroDeDocumento,
        merchantVentaMedioPago,
        merchantVentaFH,
        merchantVentaReferencia,
        merchantVentaDetalle,
        merchantVentaAutorizacion,
        merchantVentaComprobante,
        merchantVentaCanal,
        merchantVentaInformacionAutorizacion,
        merchantVentaEstado,
        merchantVentaUUID
      } = item;
      const venta = {
        id: index,
        canalCod: merchantVentaCanal,
        infoAutorizacion: merchantVentaInformacionAutorizacion,
        [titles[0]]: `${transformDate(
          merchantVentaFH?.substring(0, 10)
        )} ${merchantVentaFH?.substring(11, 16)}`,
        [titles[1]]: merchantVentaAutorizacion
          ? `${transformDate(
              merchantVentaAutorizacion.substring(0, 10)
            )} ${merchantVentaAutorizacion.substring(11, 16)}`
          : "",
        [titles[2]]: estados.filter(e => e.estadoId === merchantVentaEstado)[0]?.estadoNombre,
        [titles[3]]: merchantVentaMonto,
        [titles[4]]: canales.filter(i => i.canalId === merchantVentaCanal)[0]?.canalNombre,
        [titles[5]]:
          merchantVentaMedioPago === "H"
            ? "Billetera"
            : merchantVentaMedioPago === "C"
            ? "TC - " + merchantVentaDetalle
            : merchantVentaMedioPago === "D"
            ? "TD - " + merchantVentaDetalle
            : merchantVentaMedioPago === "B"
            ? "BNLP"
            : "Transferencia",
        [titles[6]]: merchantVentaNombreCompleto,
        [titles[7]]: merchantVentaNroDeDocumento,
        [titles[8]]: merchantVentaReferencia,
        [titles[9]]: merchantVentaComprobante,
        [titles[10]]: merchantVentaUUID
      };
      return [...acc, venta];
    }, []);
    setVentas(ventas);
    setCargando(false);
  }
  useEffect(() => {
    if (Object.keys(credentials).length > 0) retrieveVentas();
  }, [credentials, filtros]);

  useEffect(() => {
    setRoute(Routes[window.location.pathname.split("/")[1]]);
    setRow({ status: false, row: {} });
  }, []);
  
  return (
    <main>
      <Modal open={modalDetails.isOpen} title={modalDetails.title} onClose={closeModal} /* close={modalDetails.procede === ACTIONS.EXPORT || modalDetails.procede === "ASIGNAR" ? true : false} */ >
            {modalDetails.procede === ACTIONS.DETAIL && (
                <VentasDetail
                    user={row.row}
                    // servicio={service}
                    // updateList={() => getEmpleados(credentials)}
                    closeModal={closeModal}
                />
            )}
        </Modal>
        <div style={{display: "flex", alignItems: "end"}}>
      <Filtros
        titles={titles}
        rows={ventas}
        filtros={filtros}
        setFiltros={setFiltros}
        updateList={retrieveVentas}
        isSales
        metodosOptions={metodos}
        canalOptions={canales}
        estadosOptions={estados}
        tableName={`ventas_${filtros.desde}_${filtros.hasta}`}
      />
      <div style={{marginBottom: "20px"}}>
      <HeaderButton
          text={"Detalle de venta"}
          handleClick={handleClick}
          data={{
              title: "Detalle de venta",
              procede: ACTIONS.DETAIL
          }}
          disabled={!row.status}
      >
          <RemoveRedEyeIcon />
      </HeaderButton>
      </div>
      </div>
      <div className="row-grid" id="grid-container">
        {cargando ? (
          <CircularIndeterminate />
        ) : (
          <XGridDemo rows={ventas} titles={titles} loadPage={loadPage} hideTotal={credentials.rolCod === 'VOP'}/>
        )}
      </div>
    </main>
  );
}
